import NotificationComponent from "@/core/notification-component/notification-component.vue";
import NotificationDetails from "@/core/notification-component/notification-details/notification-details.vue";
import Dashboard from "@/dashboard/dashboard.vue";
import { MyOrders } from "@/dashboard/my-orders/my-orders";
import { MySettings } from "@/dashboard/my-settings/my-settings";
import { environment } from "@/environments/environment";
import Skeleton from "@/shared/vehicles/skeleton/skeleton.vue";
import AppPagination from "@/shared/components/app-pagination/app-pagination.vue";
import BaseButton from "@/shared/components/base/BaseButton.vue";
import BaseButtonLink from "@/shared/components/base/BaseButtonLink.vue";
import BaseCheckbox from "@/shared/components/base/BaseCheckbox.vue";
import BaseCheckboxList from "@/shared/components/base/BaseCheckboxList.vue";
import BaseFooter from "@/shared/components/base/BaseFooter.vue";
import BaseHeader from "@/shared/components/base/BaseHeader.vue";
import BaseInput from "@/shared/components/base/BaseInput.vue";
import { appAuthRequired } from "@/shared/directives/app-auth-required";
import { appGalleryDirective } from "@/shared/directives/app-gallery";
import store from "@/store";
import { staticLib } from "@public/js/static-lib.js";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import AutoComplete from "primevue/autocomplete";
import BlockUI from "primevue/blockui";
import Tooltip from "primevue/tooltip";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import PrimeVue from "primevue/config";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import ProgressSpinner from "primevue/progressspinner";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/saga-blue/theme.css";
import ScrollPanel from "primevue/scrollpanel";
import Sidebar from "primevue/sidebar";
import Tag from "primevue/tag";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import "tippy.js/animations/shift-away.css";
import "tippy.js/themes/light.css";
import { createApp } from "vue";
import VueTippy from "vue-tippy/dist/vue-tippy.esm";
import App from "./App.vue";
import "./main.scss";
import NotFoundComponent from "./pages/not-found/not-found.vue";
import WorkInProgress from "./pages/work-in-progress/work-in-progress.vue";
import router from "./router";
import { routerModel } from "./router/router.model";
import AppAddressFieldComponent from "./shared/components/app-address-field/app-address-field.vue";
import AppBlockUIComponent from "./shared/components/app-block-ui/app-block-ui.vue";
import AppBreadcrumbs from "./shared/components/app-breadcrumbs/app-breadcrumbs.vue";
import AppCarCardComponent from "./shared/components/app-vehicle-card/app-vehicle-card.vue";
import AppCarCardGridComponent from "./shared/components/app-vehicle-card-grid/app-vehicle-card-grid.vue";
import AppVehicleOptionsComponent from "./shared/components/app-vehicle-options/app-vehicle-options.vue";
import AppCheckboxComponent from "./shared/components/app-checkbox/app-checkbox.vue";
import AppDropdownRangeComponent from "./shared/components/app-dropdown-range/app-dropdown-range.vue";
import AppDropdownComponent from "./shared/components/app-dropdown/app-dropdown.vue";
import AppFormatCurrencyComponent from "./shared/components/app-format-currency/app-format-currency.vue";
import AppFormatDateComponent from "./shared/components/app-format-date/app-format-date.vue";
import AppFormatNumberComponent from "./shared/components/app-format-number/app-format-number.vue";
import AppFormatTimeComponent from "./shared/components/app-format-time/app-format-time.vue";
import AppFormatUnitComponent from "./shared/components/app-format-unit/app-format-unit.vue";
import AppFullscreenSpinner from "./shared/components/app-fullscreen-spinner/app-fullscreen-spinner.vue";
import AppLinkComponent from "./shared/components/app-link/app-link.vue";
import AppRangeSliderComponent from "@/shared/vehicles/left-filter/range-slider/range-slider.vue";
import AppTagComponent from "./shared/components/app-tag/app-tag.vue";
import AppVivitionComponent from "./shared/components/app-vivition/app-vivition.vue";
import AppVehiclePrintComponent from "./shared/components/app-vehicles-print/app-vehicles-print.vue";
import { appChartDirective } from "./shared/directives/app-chart";
import { appFastGalleryDirective } from "./shared/directives/app-fast-gallery";
import { appHeaderBtnDirective } from "./shared/directives/app-header-btn";
import { appNouisliderDirective } from "./shared/directives/app-nouislider";
import { appScrollSpyDirective } from "./shared/directives/app-scroll-spy";
import { appSliderDirective } from "./shared/directives/app-slider";
import { appSmoothScrollToDirective } from "./shared/directives/app-smooth-scroll";
import { appStickyDirective } from "./shared/directives/app-sticky";
import { appTippyVisible } from "./shared/directives/app-tippy-visible";
import vClickOutside from "./shared/directives/click-outside";
import { appFitCanvasToContainerDirective } from "./shared/directives/fit-canvas-to-container";
import { i18n } from "./shared/i18n/i18n";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AppSidebarComponent from "./shared/components/app-sidebar/app-sidebar.vue";
import AppModal from "@/shared/components/app-modal/app-modal.vue";
import FancyboxGallery from "@/shared/components/fancybox/fancybox.vue";
staticLib.init();

const app = createApp(App);

app.use(PrimeVue);
app.use(i18n);
app.use(ToastService);
app.use(VueTelInput);

app.directive("clickOutside", vClickOutside);
app.directive("appSticky", appStickyDirective);
app.directive("appFitCanvasToContainer", appFitCanvasToContainerDirective);
app.directive("appChart", appChartDirective);
app.directive("appSmoothScrollTo", appSmoothScrollToDirective);
app.directive("appScrollSpy", appScrollSpyDirective);
app.directive("appNouislider", appNouisliderDirective);
app.directive("appGallery", appGalleryDirective);
app.directive("appFastGallery", appFastGalleryDirective);
app.directive("appHeaderBtn", appHeaderBtnDirective);
app.directive("appSlider", appSliderDirective);
app.directive("appTippyVisible", appTippyVisible);
app.directive("appAuthRequired", appAuthRequired);
app.directive("tooltip", Tooltip);

app.use(VueTippy, {
    directive: "tippy", // => v-tippy
    component: "vue-tippy", // => <vue-tippy/>
    componentSingleton: "tippy-singleton", // => <tippy-singleton/>
});

app.provide("googleMapApiKey", environment.mapsKey);

app.component("p-dialog", Dialog);
app.component("p-sidebar", Sidebar);
app.component("p-spinner", ProgressSpinner);
app.component("p-button", Button);
app.component("p-divider", Divider);
app.component("p-toast", Toast);
app.component("p-scrollpanel", ScrollPanel);
app.component("p-tag", Tag);
app.component("p-calendar", Calendar);
app.component("p-block-ui", BlockUI);
app.component("p-autocomplete", AutoComplete);
app.component("app-not-found", NotFoundComponent);
app.component("app-work-in-progress", WorkInProgress);
app.component("app-address-field", AppAddressFieldComponent);
app.component("app-fullscreen-spinner", AppFullscreenSpinner);
app.component("app-vivition", AppVivitionComponent);
app.component("app-tag", AppTagComponent);
app.component("app-block-ui", AppBlockUIComponent);
app.component("app-breadcrumbs", AppBreadcrumbs);
app.component("app-sidebar", AppSidebarComponent);
app.component("app-link", AppLinkComponent);
app.component("app-dropdown", AppDropdownComponent);
app.component("app-range-slider", AppRangeSliderComponent);
app.component("app-vehicle-options", AppVehicleOptionsComponent);
app.component("app-car-card", AppCarCardComponent);
app.component("app-car-card-grid", AppCarCardGridComponent);
app.component("app-dropdown-range", AppDropdownRangeComponent);
app.component("app-format-currency", AppFormatCurrencyComponent);
app.component("app-format-date", AppFormatDateComponent);
app.component("app-format-time", AppFormatTimeComponent);
app.component("app-format-unit", AppFormatUnitComponent);
app.component("app-format-number", AppFormatNumberComponent);
app.component("app-checkbox", AppCheckboxComponent);
app.component("app-pagination", AppPagination);
app.component("app-vehicles-print", AppVehiclePrintComponent);
app.component("base-button", BaseButton);
app.component("base-input", BaseInput);
app.component("base-checkbox", BaseCheckbox);
app.component("base-button-link", BaseButtonLink);
app.component("base-checkbox-list", BaseCheckboxList);
app.component("base-header", BaseHeader);
app.component("base-footer", BaseFooter);
app.component("app-card-skeleton", Skeleton);
app.component("notification-component", NotificationComponent);
app.component("notification-details", NotificationDetails);
app.component("dashboard", Dashboard);
app.component("my-settings", MySettings);
app.component("my-orders", MyOrders);
app.component("app-modal", AppModal);
app.component("app-fancybox", FancyboxGallery);

routerModel.loadRoutes().then((routes) => {
    if (!routes) return;
    app.use(store).use(router(routes.value)).mount("#app");
});
